<h2 style="background: var(--ion-color-secondary-shade) !important;color: white;" mat-dialog-title class="dialog-title">
Export {{SelectedType}}</h2>
<div mat-dialog-content class="dialog-body">
  <h3 style="line-height: normal;">You can only export property data for up to 90 days.</h3>
  <form [formGroup]="dateRangeForm" class="date-range-form" novalidate>
    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>From Date</mat-label>
        <input matInput [matDatepicker]="fromPicker" formControlName="fromDate" placeholder="Select start date"
          [max]="today">
          <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
          @if (fromDateCtrl?.hasError('required')) {
            <mat-error>From date is required</mat-error>
          }
          @if (fromDateCtrl?.hasError('future')) {
            <mat-error>Cannot be in the future</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>To Date</mat-label>
          <input matInput [matDatepicker]="toPicker" formControlName="toDate" placeholder="Select end date"
            [min]="toDateMin" [max]="toDateMax">
            <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
            @if (toDateCtrl?.hasError('required')) {
              <mat-error>To date is required</mat-error>
            }
          </mat-form-field>
        </div>
        @if (dateRangeForm.errors && (fromDateCtrl?.touched || toDateCtrl?.touched)) {
          <div class="validation-summary">
            <mat-icon color="warn">error_outline</mat-icon>
            @if (dateRangeForm.hasError('order')) {
              <span>To date must be same day or after From date.</span>
            }
            @if (dateRangeForm.hasError('rangeTooLong')) {
              <span>Date range cannot exceed 90 days.</span>
            }
          </div>
        }

        Date Range : {{dateRangeForm.value.fromDate | date }} {{dateRangeForm.value.toDate ? 'to' : ''}} {{dateRangeForm.value.toDate |
        date}}
      </form>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-stroked-button (click)="close()" >Cancel</button>
      <button mat-raised-button color="primary" class="import-button" (click)="export()"
        [disabled]="dateRangeForm.invalid">

        Export
      </button>
    </div>